/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { CustomStepProgress } from "../../CashBooking/BookingSteps/customProgress";
import { ReactComponent as book } from "../../../assests/images/onbording/booking-detils-step-icon.svg";
import { ReactComponent as firm } from "../../../assests/images/onbording/firm-details-step-icon.svg";
import { ReactComponent as personal } from "../../../assests/images/onbording/personal-details-step-icon.svg";
import { ReactComponent as delivery } from "../../../assests/images/onbording/delivery-details-step-icon.svg";
import { ReactComponent as miscellaneous } from "../../../assests/images/onbording/miscellaneous-details-step-icon.svg";
import { ReactComponent as CalIcon } from "../../../assests/images/SVG/calIcon.svg";

import CpDetails from "./CpDetails";
import FirmDetails from "./FirmDetails";
import PersonalDetails from "./PersonalDetails";
import DeliveryDetails from "./DeliveryDetails";
import MiscellaneousDetails from "./Miscellaneous Details";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import axios from "axios";

import "./style.scss";
import { primiseTable } from "../../../actionsMethods/masterMethods";
import { APIs } from "../../../utils/worker";
import { message } from "antd";

function OnboringSteps({ goToViewCp, onChange, responseFromChild }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [screen, setScreen] = useState(0);
  const [cpPirview, setCpPirview] = useState(true);
  const [formRerender, setFormRerender] = useState(false);
  const history = useLocation();
  const [apiResponse, setapiResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  let refreshData = localStorage.getItem("refreshData");
  let userData = JSON.parse(localStorage.getItem("userinfo"));

  const apiTriger = () => {
    setLoading(true);
    let userData = JSON.parse(localStorage.getItem("userinfo"));
    const headers = {
      userName: userData?.userName,
    };
    axios
      .get(`${APIs.baseURL}/cp-onboarding/v1/getCpDetail/${userData?.userId}`, {
        // .get(`${APIs.baseURL}/cp-onboarding/v1/getCpDetail/${66}`, {
        headers: headers,
      })
      .then((response) => {
        responseFromChild(response.data);
        setapiResponse(response.data);

        setLoading(false);
      })
      .catch((error) => {
        message.error("Somthing went wrong");
      });
  };

  useEffect(() => {
    if (screen == 0 || screen == 4) apiTriger();
  }, [screen]);

  const apiResponseCallBack = (val) => {
    setapiResponse(val);
  };

  // useEffect(() => {
  //   const state = history?.state?.screen;
  //   console.log(state);
  //   switch (+state) {
  //     case 0:
  //       setScreen(0);
  //       break;
  //     case 1:
  //       setScreen(1);
  //       break;
  //     case 2:
  //       setScreen(2);
  //       break;
  //     case 3:
  //       setScreen(3);
  //       break;

  //     default:
  //       setScreen(0);

  //       break;
  //   }
  // }, []);

  // useEffect(() => {
  //   console.log(refreshData);
  //   if (JSON.parse(refreshData) !== null) {
  //     setScreen(1);
  //   }
  // }, [refreshData]);

  function handleScreen(val) {
    return setScreen(val);
  }
  useEffect(() => {
    scrollTo(50, 50);
  }, [screen]);

  const reRenderCallback = () => {
    setScreen(0);
    setFormRerender(!formRerender);
  };

  const steps = [
    {
      step: 1,
      title: "CP Details",
      icon: book,
      content: (
        <CpDetails
          screen={handleScreen}
          currentScreen={screen}
          check={formRerender}
          cpResponse={apiResponse}
          callBack={apiResponseCallBack}
          loadingoutSide={loading}
        />
      ),
    },
    {
      step: 2,
      title: "Firm Details",
      icon: firm,
      content: (
        <FirmDetails
          screen={handleScreen}
          currentScreen={screen}
          apiResponse={apiResponse}
          check={formRerender}
        />
      ),
    },
    {
      step: 3,
      title: "Proprietor details",
      content: (
        <PersonalDetails
          screen={handleScreen}
          currentScreen={screen}
          check={formRerender}
          apiResponse={apiResponse}
        />
      ),
      icon: personal,
    },

    {
      step: 4,
      title: "Miscellaneous Details",
      content: (
        <MiscellaneousDetails
          screen={handleScreen}
          currentScreen={screen}
          goToViewCp={goToViewCp}
          check={formRerender}
          apiResponse={apiResponse}
        />
      ),
      icon: CalIcon,
    },
    {
      step: 5,
      title: "Delivery Details",
      content: (
        <DeliveryDetails
          screen={handleScreen}
          currentScreen={screen}
          cpPirview={cpPirview}
          onChange={onChange}
          reRenderCallback={reRenderCallback}
          check={formRerender}
          apiResponse={apiResponse}
          callBack={apiResponseCallBack}
        />
      ),
      icon: delivery,
    },
  ];

  return (
    <>
      <div className="steps-container-cp" style={{ width: "100%", margin: 0 }}>
        <CustomStepProgress steps={steps} handleScreen={screen} />
      </div>
    </>
  );
}

export default OnboringSteps;
